import meta from './data/meta.json';

const headline = meta['headline'];
const subtitle = meta['subhed'];


// keyURL is a shortcut for the generic submission link
const keyURL = meta['slug'];
const submissionURL = `https://submission.cnn.io/v3/forms/${keyURL}`;

// ./index.js has a check to make sure the date is valid
const expirationDate = new Date(meta['expiration']);

export {
  headline,
  subtitle,
  submissionURL,
  expirationDate,
};
